import { render } from "./LeadStatusComponent.vue?vue&type=template&id=63263b86"
import script from "./LeadStatusComponent.vue?vue&type=script&lang=js"
export * from "./LeadStatusComponent.vue?vue&type=script&lang=js"

import "./LeadStatusComponent.vue?vue&type=style&index=0&id=63263b86&lang=scss"
script.render = render

export default script